import { load } from "../events/load.js";
import { clickOn } from "../events/click.js";
import { loadMorePosts } from "./getNewCarts.js";
import { sceleton } from "./sceletonElement.js";
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);
import { apartments } from "./apartments.js";
import { getPage } from "../events/getPage.js";
import { setValue } from "../range.js";

if (getPage() === "apartments" || getPage() === "планування") {
  load(apartments.init.bind(apartments));
}

clickOn("#apartamentsList .load-more", () => {
  sceleton.spawn(3);
	if(apartments.emptyFilters() && apartments.list.length >= apartments.onPage.length + 4){
		apartments.addOnPage(apartments.list.slice(apartments.onPage.length, apartments.onPage.length + 4));
	}else if(apartments.hidden.length > 0){
		console.log(apartments.hidden);
		apartments.addOnPage(apartments.getHidden(4))
		sceleton.remove();
	}else{
		document.dispatchEvent(
			new CustomEvent("apaprtment_getProducts", {
				detail: {
					postType: "apartment",
					callback: ({ data = [] }) => {
						sceleton.remove();
						apartments.addMore.remove();
						if (data.length === 0) {
							return;
						}
						if (apartments.emptyFilters()) {
							console.log(data);
							data.forEach((apartment) => {
								apartments.add(apartments.template(apartment));
							});
							console.log(apartments.list);
						}
						let firstAdded = null;
						data.forEach((apartment) => {
							apartments.addOnPage(apartments.template(apartment));
							if (firstAdded === null) {
								firstAdded = apartments.container.querySelector(
									".element:last-child"
								).offsetTop;
							}
						});
						if (data.length === 4) {
							apartments.addMore.spawn();
						}
						gsap.to(window, {
							duration: 1.5,
							scrollTo: firstAdded - 100,
							ease: "power1.inOut",
						});
					},
					receivedCount: apartments.emptyFilters()
						? apartments.list.length
						: apartments.onPage.length,
				},
			})
		);
	}
});

import { closeAccordeons } from "../accordeonFunctions.js";

clickOn("#apartments #clear", () => {
  apartments.clearFilters();
  closeAccordeons("rooms");
  closeAccordeons("area");
  closeAccordeons("floors");
  setValue([0, 30]);
});
